import React from 'react'

const Footer = () => {
    return (
        <>
            <footer className="bg-gray-800 py-12">
                <div className="container mx-auto px-8 md:w-1/4">
                <form action="#" method="POST">
                    <div>
                    <label
                        htmlFor="email_address"
                        className="block text-white text-sm font-medium"
                    >
                        Enter your email to stay in touch!
                    </label>
                    <div className="mt-1.5 relative">
                        <input
                        type="text"
                        className="block w-full text-white bg-gray-600 border-2 border-transparent focus:border-white focus:ring-0 transition"
                        />
                        <div
                        className="absolute inset-0 border-b-2 border-white pointer-events-none"
                        aria-hidden
                        ></div>
                    </div>
                    </div>
                    <div className="mt-6">
                    <button
                        type="submit"
                        className="block w-full px-4 py-3 rounded bg-gray-600 text-white font-bold text-sm uppercase tracking-widest hover:bg-white hover:text-gray-900 focus:bg-white focus:text-gray-900 focus:outline-none"
                    >
                        Sign up
                    </button>
                    </div>
                </form>
                </div>

                <div className="mt-10 max-w-screen-lg xl:max-w-screen-xl mx-auto divide-y text-white px-4 sm:px-6 md:px-8 ">
                <ul className="text-xs pb-14 sm:pb-20 grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-10 text-center">
                    <li className="space-y-5 row-span-2 md:text-left">
                    <h2 className="text-sm font-semibold text-white uppercase">
                        Help
                    </h2>
                    <ul className="space-y-4">
                        <li>
                        <a
                            className=""
                            href="#"
                        >
                            1-888-963-8944
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            1-814-251-9966
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            help@allbirds.com
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            Returns/Exchanges
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            FAQ/Contact Us
                        </a>
                        </li>
                    </ul>
                    </li>
                    <li className="space-y-5 row-span-2 md:text-left">
                    <h2 className="text-sm font-semibold text-white uppercase">
                        Shop
                    </h2>
                    <ul className="space-y-4">
                        <li>
                        <a
                            href="#"
                        >
                            Men's Shoes
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            Women's Shoes
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            Men's Apparel
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            Women's Apparel
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            Socks
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            Gift Cards
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            Download the Allbirds App
                        </a>
                        </li>
                        
                    </ul>
                    </li>
                    <li className="space-y-5 row-span-2 md:text-left">
                    <h2 className="text-sm font-semibold text-white uppercase">
                        Company
                    </h2>
                    <ul className="space-y-4">
                        <li>
                        <a
                            href="#"
                        >
                            Our Stores
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            Our Story
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            Our Materials
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            Sustainability
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            Partnership
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            Affiliates
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            Bulk Orders
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            Careers
                        </a>
                        </li>
                        <li>
                        <a
                            href="#"
                        >
                            Press
                        </a>
                        </li>
                    </ul>
                    </li>
                    <li className="space-y-5 md:text-left">
                    <h2 className="text-lg font-semibold text-white uppercase">
                        FOLLOW THE FLOCK
                    </h2>
                    <p className="text-white leading-relaxed">Exclusive offers, a heads up on new things, and sightings of Allbirds in the wild. Oh, we have cute sheep, too. #weareallbirds</p>
                    
                    <div className="items-center min-w-full">
                        <div className="flex-auto">
                        <ul className="inline-flex space-x-5 ">
                            <li>
                            <a
                                className=""
                                href="#"
                            >
                                <img src="https://cdn.allbirds.com/image/upload/q_auto/production/anchorLink/en-US/images/7ALf4NFNH4VStmrXU0qSKK/1" alt="" />
                            </a>
                            </li>
                            <li>
                            <a
                                className=""
                                href="#"
                            >
                                <img src="https://cdn.allbirds.com/image/upload/q_auto/production/anchorLink/en-US/images/7jsrb2oMQypD1kO6iZLXZN/1" alt="" />
                            </a>
                            </li>
                            <li>
                            <a
                                className=""
                                href="#"
                            >
                                <img src="https://cdn.allbirds.com/image/upload/q_auto/production/anchorLink/en-US/images/55ZLXdMQu728huA78Qlfkb/1" alt="" />
                            </a>
                            </li>
                            <li>
                            <a
                                className=""
                                href="#"
                            >
                                <img src="https://cdn.allbirds.com/image/upload/q_auto/production/anchorLink/en-US/images/5VBkylibm5XkgzjDP153Mo/1" alt="" />
                            </a>
                            </li>
                        </ul>
                        </div>  
                    </div>                            
                                                
                    
                    </li>
                </ul>
                
                </div>

                <div className="container mx-auto px-3">
                <div className="">
                    <p className="text-xs text-white leading-relaxed text-center">© 2021 Allbirds, Inc. All Rights Reserved. Terms, Privacy & Accessibility</p>
                </div>
                </div>
            </footer>
        </>
    )
}

export default Footer
